/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line import/no-extraneous-dependencies
import { useMutation, useQuery } from "@tanstack/react-query";
import { client } from "./api-client";
import type { DashboardFilters } from "utils/types/global.types";

export const useGetAtmServices = (data: DashboardFilters) =>
  useQuery<any[]>({
    queryKey: [
      "GetAtmServices",
      data.period,
      data.cashCenterId,
      data.currency,
      data.currentDate,
      data.customerId,
      data.fromDate,
      data.locationType,
      data.routeNo,
      data.serviceType,
      data.toDate,
    ],
    queryFn: () => client(`dashboards/atm/services`, { data }),
  });

export const useGetCitServices = (data: DashboardFilters) =>
  useQuery<any[]>({
    queryKey: [
      "GetCitServices",
      data.period,
      data.cashCenterId,
      data.currency,
      data.currentDate,
      data.customerId,
      data.fromDate,
      data.locationType,
      data.routeNo,
      data.serviceType,
      data.toDate,
    ],
    queryFn: () => client(`dashboards/cit/services`, { data }),
  });

export const useGetAtmProcessedCash = (data: DashboardFilters) =>
  useQuery<{ result: any[] }>({
    queryKey: [
      "GetAtmProcessedCash",
      data.period,
      data.cashCenterId,
      data.currency,
      data.currentDate,
      data.customerId,
      data.fromDate,
      data.locationType,
      data.routeNo,
      data.serviceType,
      data.toDate,
    ],
    queryFn: () => client(`dashboards/atm/processed/cash`, { data }),
  });

export const useGetCitProcessedCash = (data: DashboardFilters) =>
  useQuery<{ noOfOrders: number; result: any[] }>({
    queryKey: [
      "GetCitProcessedCash",
      data.period,
      data.cashCenterId,
      data.currency,
      data.currentDate,
      data.customerId,
      data.fromDate,
      data.locationType,
      data.routeNo,
      data.serviceType,
      data.toDate,
    ],
    queryFn: () => client(`dashboards/cit/processed/cash`, { data }),
  });

export const useGetVaultStatus = (
  data: Omit<DashboardFilters, "toDate" | "fromDate">
) =>
  useQuery<any>({
    queryKey: [
      "GetVaultStatus",
      data.period,
      data.cashCenterId,
      data.currency,
      data.currentDate,
      data.customerId,
      data.locationType,
      data.routeNo,
      data.serviceType,
    ],
    queryFn: () => client(`dashboards/vault/status`, { data }),
  });

export const useGetVansStatus = (
  data: Omit<DashboardFilters, "toDate" | "fromDate">
) =>
  useQuery<any[]>({
    queryKey: [
      "GetVansStatus",
      data.period,
      data.cashCenterId,
      data.currency,
      data.currentDate,
      data.customerId,
      data.locationType,
      data.routeNo,
      data.serviceType,
    ],
    queryFn: () => client(`dashboards/cash/vans/status`, { data }),
  });

export const useGetDispatchedVans = (
  data: Omit<DashboardFilters, "toDate" | "fromDate">
) =>
  useQuery<any[]>({
    queryKey: [
      "GetDispatchedVans",
      data.period,
      data.cashCenterId,
      data.currency,
      data.currentDate,
      data.customerId,
      data.locationType,
      data.routeNo,
      data.serviceType,
    ],
    queryFn: () => client(`dashboards/dispatched/vans`, { data }),
  });

export const useGetEndOfDayProgress = (
  data: Omit<DashboardFilters, "toDate" | "fromDate">
) =>
  useQuery<number>({
    queryKey: [
      "GetEndOfDayProgress",
      data.period,
      data.cashCenterId,
      data.currency,
      data.currentDate,
      data.customerId,
      data.locationType,
      data.routeNo,
      data.serviceType,
    ],
    queryFn: () => client(`dashboards/end/of/day/progress`, { data }),
  });

export const useGetOutgoingVaultHoldings = () =>
  useMutation<any[], unknown, string>({
    mutationFn: (sealNo: any) =>
      client(`field/operations/vh/outgoing/requests/${sealNo}`),
  });
